/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import {
  GetPurchaseOrderListResponse,
  GetPurchaseOrderListResponseArray,
} from "../../../@types/DRO/PurchaseOrderResponse";
import { ProductOrderApi } from "../../../api/ProductOrder/ProductOrderApi";
import TableHeadComponent from "./TableHead/TableHeadComponent";

const OrderHistoryComponent = () => {
  const [expandedRows, setExpandedRows] = useState<Record<number, boolean>>({});
  const [data, setData] = useState<GetPurchaseOrderListResponseArray[]>([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchProductOrderData();
  }, [page, pageSize, search]);

  const fetchProductOrderData = async () => {
    try {
      const response: GetPurchaseOrderListResponse =
        await ProductOrderApi.api.getPurchaseOrderList(page, pageSize, search);
      setData(response.data.data);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching product order data:", error);
    }
  };

  const toggleRow = (id: number) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  const handleExport = () => {
    console.log("Exporting data...");
  };

  const orderTableHead = [
    "ID",
    "Order ID",
    "Creation Date",
    "Vendor Name",
    "Status",
    "Amount",
  ];

  return (
    <div className="flex flex-col bg-white rounded-lg shadow-md overflow-hidden">
      <div className="p-4 flex justify-end items-center">
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={handleSearchChange}
          className="p-2 mr-4 border border-gray-300 rounded-lg"
        />
        <button
          onClick={handleExport}
          className="p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors">
          Export All
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <TableHeadComponent columns={orderTableHead} />
          <tbody>
            {data.map((row, index) => (
              <React.Fragment key={row.id}>
                <tr className="hover:bg-gray-50 transition-colors">
                  <td className="p-4 text-sm text-gray-700">{index + 1}</td>
                  <td className="p-4 text-sm text-gray-700">{row.id}</td>
                  <td className="p-4 text-sm text-gray-700">
                    {row.confirmationDate}
                  </td>
                  <td className="p-4 text-sm text-gray-700">
                    {row.vendorDetails.vendorName}
                  </td>
                  <td className="p-4">
                    <span
                      className={clsx(
                        "inline-block px-3 py-1 text-xs font-semibold text-white rounded-full",
                        getStatusClass(row?.status?.name)
                      )}>
                      {row.status?.name}
                    </span>
                  </td>
                  <td className="p-4 text-sm text-gray-700">
                    {row.amount || "N/A"}
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      <div className="p-4 flex justify-between items-center">
        <button
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          disabled={page === 1}
          className="p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors disabled:bg-gray-300">
          Previous
        </button>
        <span>
          Page {page} of {totalPages}
        </span>
        <button
          onClick={() => setPage((prev) => prev + 1)}
          disabled={page === totalPages}
          className="p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors disabled:bg-gray-300">
          Next
        </button>
      </div>
    </div>
  );
};

const getStatusClass = (status: string): string => {
  const statusClasses: Record<string, string> = {
    DRAFT: "bg-gray-400",
    CREATED: "bg-blue-400",
    COMPLETED: "bg-green-400",
    APPROVED: "bg-yellow-400",
  };
  return statusClasses[status] || "bg-gray-400";
};

export default OrderHistoryComponent;
